import noop from 'lodash/noop';
import React from 'react';
import { Result as LogoutResult } from './hooks/useOAuthLogout';
import { Result as LoginResult } from './hooks/useOAuthLogin';

interface Context {
  login: LoginResult['login'];
  logout: LogoutResult['logout'];
}

const OAuthContext = React.createContext<Context>({
  login: noop,
  logout: noop,
} as Context);

export default OAuthContext;
